var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.facet.name
    ? _c(
        "div",
        { staticClass: "facet" },
        [
          _c(
            "div",
            {
              staticClass: "h3",
              attrs: { tabindex: "0" },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  return _vm.toggleFacet.apply(null, arguments)
                },
                click: _vm.toggleFacet,
              },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.facetName)),
                _vm.activeValues > 0
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(" (" + _vm.activeValues + ")"),
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "toggleIcon",
                  class: { active: _vm.facetOpen },
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "24",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [_c("polyline", { attrs: { points: "6 9 12 15 18 9" } })]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "slide-up-down",
            { attrs: { duration: 500, active: _vm.facetOpen } },
            [
              _vm.facet.type === "price"
                ? _c(
                    "div",
                    {
                      staticClass: "facetValues",
                      class: { open: _vm.facetOpen },
                    },
                    [_c("item-filter-price")],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "facetValues",
                      class: { open: _vm.facetOpen },
                    },
                    _vm._l(_vm.facets, function (value) {
                      return _c(
                        "div",
                        {
                          key: value.id,
                          staticClass: "facetValue",
                          class: { selected: value.selected },
                        },
                        [
                          _c("input", {
                            staticClass: "facet-value-input pseudoHide",
                            attrs: {
                              id: "option-" + value.id + "-" + _vm._uid,
                              type: "checkbox",
                              disabled: _vm.isLoading || value.count <= 0,
                            },
                            domProps: { checked: _vm.isSelected(value.id) },
                            on: {
                              change: function ($event) {
                                return _vm.updateFacet(value)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "facet-value-label",
                            class: [
                              _vm.paddingClasses,
                              _vm.isSelected(value.id) ? "bg-appearance" : "",
                              "option-" + value.id,
                            ],
                            style: _vm.paddingInlineStyles,
                            attrs: {
                              for: "option-" + value.id + "-" + _vm._uid,
                            },
                            domProps: { innerHTML: _vm._s(value.name) },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }